import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { publicApi, API } from "@/lib/api";
import Logo from "@/components/Logo";

export default function PublicMenu() {
  const [data, setData] = useState({ categories: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await publicApi.get(`${API}/public/menu`);
        setData(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="public-menu-page">
      <header className="px-5 sm:px-10 py-6 border-b border-white/10 flex items-center justify-between">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-[#C9963F] text-xs uppercase tracking-[0.2em]">
          <ArrowLeft size={14} /> Home
        </Link>
        <Logo size="sm" />
        <Link to="/inquire" data-testid="menu-inquire-btn"
          className="inline-flex items-center gap-2 bg-[#C9963F] text-black px-4 py-2 text-sm font-medium hover:bg-[#A67A2D]">
          Submit Inquiry <ArrowRight size={14} />
        </Link>
      </header>

      <div className="px-5 sm:px-10 lg:px-20 py-14 max-w-6xl mx-auto">
        <div className="text-[10px] uppercase tracking-[0.4em] text-[#C9963F] mb-3">Catering Menu</div>
        <h1 className="font-serif-brand text-5xl sm:text-6xl mb-3">Our menu.</h1>
        <p className="text-white/50 mb-12 max-w-xl text-sm">
          Mix and match across our signature stations. Pricing tailored to your event size — submit an inquiry for a custom quote.
        </p>

        {loading && <div className="text-white/40">Loading…</div>}

        <div className="space-y-12">
          {data.categories.map((cat) => (
            <section key={cat.name} data-testid={`menu-cat-${cat.name}`}>
              <div className="flex items-baseline gap-4 mb-5">
                <h2 className="font-serif-brand text-3xl text-[#C9963F] uppercase tracking-wide">{cat.name}</h2>
                <div className="flex-1 h-px bg-[#C9963F]/30" />
                <span className="text-[10px] uppercase tracking-[0.2em] text-white/40">{cat.items.length} items</span>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2">
                {cat.items.map((it) => (
                  <div key={it.id} className="text-white/85 py-1.5 border-b border-white/5">{it.name}</div>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-20 text-center">
          <Link to="/inquire" data-testid="menu-bottom-cta"
            className="inline-flex items-center gap-2 bg-[#C9963F] text-black px-8 py-4 text-sm font-medium hover:bg-[#A67A2D]">
            Submit Inquiry <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
}
